module.exports = __webpack_public_path__ + "img/Chile.ff592c6b.svg";